import { render, staticRenderFns } from "./beijingZone.vue?vue&type=template&id=09509953&scoped=true"
import script from "./beijingZone.vue?vue&type=script&lang=js"
export * from "./beijingZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09509953",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09509953')) {
      api.createRecord('09509953', component.options)
    } else {
      api.reload('09509953', component.options)
    }
    module.hot.accept("./beijingZone.vue?vue&type=template&id=09509953&scoped=true", function () {
      api.rerender('09509953', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/components/beijingZone.vue"
export default component.exports